import  React, { useEffect } from 'react'
import './nav.css'
import styled from 'styled-components'
import { Link } from 'gatsby';
import { StoreContext } from '../../context/store-context';
import { VscMenu,VscClose } from "react-icons/vsc";
import slugify from "@sindresorhus/slugify"
import TopBarProgress from "react-topbar-progress-indicator"
import { globalHistory } from '@reach/router'
import Cart from '../Cart';
import { graphql,useStaticQuery } from 'gatsby';

TopBarProgress.config({
  barColors: {
    "0": "#d0bbfe",
    "1.0": "#FDFF9E"
  },
  shadowBlur: 0
});
const Title = styled.h1
`
  color:#d0bbfe;
  z-index:1000;
  position:relative;
    margin-top:.25rem;
    user-select:none;
    font-size: 22px;
    -webkit-text-decoration: uppercase;
    text-decoration: uppercase;
    -webkit-letter-spacing: 5px;
    -moz-letter-spacing: 5px;
    -ms-letter-spacing: 5px;
    letter-spacing: 10px;
    font-weight: 400;
    text-transform: uppercase;
`

const Navbar = styled.nav
`
display:flex;
width: 100%;
max-width:100%;
`

const Wrapper = styled.div
`
display: flex;
place-items: center;
gap:2%;
`
const PageBlur = styled.div`
    opacity: .5;
    --tw-bg-opacity: 1;
    background-color: rgb(47 46 52/var(--tw-bg-opacity));
    width: 100vw;
    height: 100vh;
    z-index: 10;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    cursor: pointer;
`
const HomePageMHeader =  () => 
{
  const { checkout } = React.useContext(StoreContext)
  let CartLength = 0
  checkout.lineItems.map((item) => (
   CartLength += item.quantity
  ))
  const [isOpen,setOpen] = React.useState(false)
  const [progress, setProgress] = React.useState(false)
   const {
    allShopifyProduct: { productTypes },
  } = useStaticQuery(graphql`
    query {
      allShopifyProduct {
        productTypes: distinct(field: productType)
      }
    }
  `)
  const [toggleMenu, setToggleMenu] = React.useState(false);
useEffect(()=>
{
  if(window !== "undefined"){
    const svg = document.querySelectorAll('.svgg')
    const img = document.querySelectorAll('.img-click')
    const svg1 = document.querySelectorAll('.svgg1')
    if(toggleMenu)
    {
  
      svg.forEach(svg =>
        {
          svg.classList.add('whity')
        })
      svg1.forEach(svg =>
        {
          svg.classList.add('whity1')
        })
        img.forEach(imgg =>
          {
            imgg.classList.add('filterr')
          })
      }
      else if(toggleMenu === false  )
      {
        svg.forEach(svg =>
          {
            svg.classList.remove('whity')
          })
        svg1.forEach(svg =>
          {
            svg.classList.remove('whity1')
          })
          img.forEach(imgg =>
            {
              imgg.classList.remove('filterr')
            })
      
  }
  }

    
},[toggleMenu])



useEffect(()=>
{

  if(window !== "undefined"){
    const widthBla = window.innerWidth
    if(widthBla > 700 && toggleMenu === true)
    {
    setToggleMenu(false)
    
  }
}
}, [toggleMenu])


useEffect(() => {
  return globalHistory.listen(({ action }) => {
    if (action === 'PUSH') setProgress(true)
  })
}, [setProgress])
  useEffect(()=>
  {
    if(window !== "undefined"){
    const nav = document.querySelector('.navv')
    const navactive = document.querySelector('.navbar-active')
    const navbar = document.querySelector('.navbar')
    const height = navbar.offsetHeight
    const y_pos = navbar.offsetTop
   document.addEventListener('scroll', e =>{
     const scroll= window.scrollY
     if(scroll >height + y_pos) 
     {
        navactive.classList.remove('nav')
        nav.classList.add('fixed')
     }else if (scroll <= y_pos + 200)
     {
      navactive.classList.add('nav')
     }
   })
  }
  },[])
  
  const isOpenFunction = React.useCallback(val => {
    setOpen(val);
  }, [setOpen]);
  // React.useEffect(()=>
  // {
  //   if(isOpen)
  //   {
  //     <Cart isOpen={isOpen} />
  //   }
  // },[isOpen])
     let path = ''
  if(typeof window !== "undefined"){
  const location = window.location.pathname


  location.includes('/men') ? path = '/men' : path = '/women'
  }

  const isClick = (e) =>
  {
    setOpen(e.currentTarget)
    
  }

 return (

    <div  className='text-center text-l pl-3 font-bold bg-white'>
      {isOpen &&
       <PageBlur ></PageBlur>
      }
     
      <Cart isOpen={isOpen} parentStateSetter={isOpenFunction} >
      <VscClose className='cursor-pointer z-1000 svgg' color="#2a2a2a" size={30} onClick={() => setOpen(false)} />
        </Cart>
         {
     progress && (
      <TopBarProgress/>
     )
   }
        {/* <Slide >HERE IS A TEXT</Slide> */}
      <Title className='title-page'><Link className='link' to='/'>Lumine</Link></Title>
      <nav className='navbar-active nav' >
      <ul className='flex flex-wrap text-smol uppercase my-8  w-full font-thin navv'>
           <ul className='flex full-view'>
            <li className='m-2 title-sticky'><a href='/'>LUMINE</a></li>
            <li className='m-2 '><Link to={`${path}/products`}>All Products</Link></li>
            {productTypes.map((name) => (
              <li className='m-2 nav-links'>
        <Link
          key={name}
          to={`${path}/products/${slugify(name)}`}
        >
          {name}
        </Link>
        </li>
      ))}
            </ul>
            <ul className='flex mobilee-view'>
            {toggleMenu
            ? <VscClose className='cursor-pointer z-1000 svgg' color="#2a2a2a" size={30} onClick={() => setToggleMenu(false)} />
            : <VscMenu className='cursor-pointer z-1000 svgg' color="#2a2a2a" size={30} onClick={() => setToggleMenu(true)} />
          }
          <div className='text-center absolute w-full left-0 '>
          {/* <Slide >HERE IS A TEXT</Slide> */}
          <Title className='font-p'><Link className='men-link' to='/men'>Lum</Link><Link className='women-link' to='/women'>ine</Link></Title>

          </div>
        {toggleMenu &&
        
        <ul className='menu-items'>
          <li className='m-2'><Link to={`${path}/products`}>All Products</Link></li>
          {productTypes.map((name) => (
              <li className='m-2 nav-links'>
        <Link
          key={name}
          to={`${path}/products/${slugify(name)}`}
        >
          {name}
        </Link>
        </li>
      ))}
        </ul>

        }
            </ul>
 <Wrapper className='place-content-end flex-1	mr-8'>
  <span><svg role="presentation" className="cursor-pointer user svgg1" viewBox="0 0 33 33"><path fill="none" stroke="#0E0E0D" stroke-linejoin="round" stroke-miterlimit="10" d="M6.5,28.3c0.6-3.3,2.8-6.1,5.7-7.5 M20.7,20.9c1.1,0.5,2.1,1.2,2.9,2c1.4,1.4,2.5,3.3,2.8,5.4 M32.1,16.3c0,8.6-7,15.7-15.7,15.7s-15.7-7-15.7-15.7c0-8.6,7-15.7,15.7-15.7S32.1,7.6,32.1,16.3z M22.9,15.3 c0,4.1-2.9,7.4-6.4,7.4S10,19.4,10,15.3c0-4.1,2.9-7.4,6.4-7.4S22.9,11.3,22.9,15.3z"></path></svg></span>
  <span><svg className='search cursor-pointer svgg'  xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5z"/></svg></span>
  <span className='round-fixed'>{CartLength}</span>
  <span><svg className='cart-svg cursor-pointer ' fill="currentColor" onClick={isClick} viewBox="0 0 24 24" width="1em" height="1em" ><path d="M9.69 20.142a1.926 1.926 0 100 3.853 1.926 1.926 0 000-3.853zm0 1.5a.426.426 0 110 .853.426.426 0 010-.853zm9.412-1.5a1.927 1.927 0 100 3.853 1.927 1.927 0 000-3.853zm0 1.5a.426.426 0 110 .853.426.426 0 010-.853zM4.396.141c.317 0 .596.2.703.49l.03.1.905 4.158.045-.015a.745.745 0 01.097-.02l.102-.007H23.22a.75.75 0 01.749.792l-.013.099-1.884 9.892a3.1 3.1 0 01-2.903 2.48l-.185.002H9.94a3.101 3.101 0 01-3.058-2.293l-.042-.18L3.79 1.641H.866A.75.75 0 01.123.993L.116.891A.75.75 0 01.765.148L.866.141h3.53zm17.916 6.206H6.352l1.955 8.983c.145.71.747 1.23 1.472 1.279l.146.003H19a1.602 1.602 0 001.566-1.135l.035-.138 1.711-8.992z"></path></svg></span>
</Wrapper>
          </ul>
      </nav>
      {/*Mobile View Sticky */}
    
      {/* Menu */}
      <nav className='navbar-active nav menu' >
      <ul className='flex flex-wrap text-smol uppercase my-8  w-full font-thin navv'>
      {toggleMenu
            ? <VscClose className='cursor-pointer z-1000 svgg'  color="#2a2a2a" size={30} onClick={() => setToggleMenu(false)} />
            : <VscMenu className='cursor-pointer z-1000 svgg' color="#2a2a2a" size={30} onClick={() => setToggleMenu(true)} />
          }
          <div className='text-center absolute w-full left-0 '>
          <Title className='font-p'><Link className='men-link' to='/men'>Lum</Link><Link className='women-link' to='/women'>ine</Link></Title>

          </div>
        {toggleMenu &&
        
        <ul className='menu-items'>
        <Wrapper className='place-content-end flex-1	z-1000 '>
        <span><svg role="presentation" className="cursor-pointer user svgg1" viewBox="0 0 33 33"><path fill="none" stroke="#0E0E0D" stroke-linejoin="round" stroke-miterlimit="10" d="M6.5,28.3c0.6-3.3,2.8-6.1,5.7-7.5 M20.7,20.9c1.1,0.5,2.1,1.2,2.9,2c1.4,1.4,2.5,3.3,2.8,5.4 M32.1,16.3c0,8.6-7,15.7-15.7,15.7s-15.7-7-15.7-15.7c0-8.6,7-15.7,15.7-15.7S32.1,7.6,32.1,16.3z M22.9,15.3 c0,4.1-2.9,7.4-6.4,7.4S10,19.4,10,15.3c0-4.1,2.9-7.4,6.4-7.4S22.9,11.3,22.9,15.3z"></path></svg></span>
 <span><svg className='search cursor-pointer svgg'  xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5z"/></svg></span>
 <span className='round-1'>{CartLength}</span>
 <span><svg className='cart-svg cursor-pointer ' fill="currentColor" onClick={isClick} viewBox="0 0 24 24" width="1em" height="1em" ><path d="M9.69 20.142a1.926 1.926 0 100 3.853 1.926 1.926 0 000-3.853zm0 1.5a.426.426 0 110 .853.426.426 0 010-.853zm9.412-1.5a1.927 1.927 0 100 3.853 1.927 1.927 0 000-3.853zm0 1.5a.426.426 0 110 .853.426.426 0 010-.853zM4.396.141c.317 0 .596.2.703.49l.03.1.905 4.158.045-.015a.745.745 0 01.097-.02l.102-.007H23.22a.75.75 0 01.749.792l-.013.099-1.884 9.892a3.1 3.1 0 01-2.903 2.48l-.185.002H9.94a3.101 3.101 0 01-3.058-2.293l-.042-.18L3.79 1.641H.866A.75.75 0 01.123.993L.116.891A.75.75 0 01.765.148L.866.141h3.53zm17.916 6.206H6.352l1.955 8.983c.145.71.747 1.23 1.472 1.279l.146.003H19a1.602 1.602 0 001.566-1.135l.035-.138 1.711-8.992z"></path></svg></span>
</Wrapper>
          <li className='m-2'><Link to={`${path}/products`}>All Products</Link></li>
          {productTypes.map((name) => (
              <li className='m-2 nav-links'>
        <Link
          key={name}
          to={`${path}/products/${slugify(name)}`}
        >
          {name}
        </Link>
        </li>
      ))}
            
        </ul>

        }
        
        </ul>
      </nav>
      <Navbar className='navbar'>
          <ul className='flex flex-wrap text-smol uppercase my-8  w-full font-thin'>
          <li className='m-2 nav-links'><Link to={`${path}/products`}>All Products</Link></li>
          {productTypes.map((name) => (
              <li className='m-2 '>
        <Link
          key={name}
          to={`${path}/products/${slugify(name)}`}
        >
          {name}
        </Link>
        </li>
      ))}
 <Wrapper className='place-content-end flex-1	mr-8'>
 <span><svg role="presentation" className="cursor-pointer user svgg1" viewBox="0 0 33 33"><path fill="none" stroke="#0E0E0D" stroke-linejoin="round" stroke-miterlimit="10" d="M6.5,28.3c0.6-3.3,2.8-6.1,5.7-7.5 M20.7,20.9c1.1,0.5,2.1,1.2,2.9,2c1.4,1.4,2.5,3.3,2.8,5.4 M32.1,16.3c0,8.6-7,15.7-15.7,15.7s-15.7-7-15.7-15.7c0-8.6,7-15.7,15.7-15.7S32.1,7.6,32.1,16.3z M22.9,15.3 c0,4.1-2.9,7.4-6.4,7.4S10,19.4,10,15.3c0-4.1,2.9-7.4,6.4-7.4S22.9,11.3,22.9,15.3z"></path></svg></span>
  <span><svg className='search cursor-pointer svgg'  xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5z"/></svg></span>
  <span className='round'>{CartLength}</span>
  <span><svg className='cart-svg cursor-pointer ' fill="currentColor" onClick={isClick} viewBox="0 0 24 24" width="1em" height="1em" ><path d="M9.69 20.142a1.926 1.926 0 100 3.853 1.926 1.926 0 000-3.853zm0 1.5a.426.426 0 110 .853.426.426 0 010-.853zm9.412-1.5a1.927 1.927 0 100 3.853 1.927 1.927 0 000-3.853zm0 1.5a.426.426 0 110 .853.426.426 0 010-.853zM4.396.141c.317 0 .596.2.703.49l.03.1.905 4.158.045-.015a.745.745 0 01.097-.02l.102-.007H23.22a.75.75 0 01.749.792l-.013.099-1.884 9.892a3.1 3.1 0 01-2.903 2.48l-.185.002H9.94a3.101 3.101 0 01-3.058-2.293l-.042-.18L3.79 1.641H.866A.75.75 0 01.123.993L.116.891A.75.75 0 01.765.148L.866.141h3.53zm17.916 6.206H6.352l1.955 8.983c.145.71.747 1.23 1.472 1.279l.146.003H19a1.602 1.602 0 001.566-1.135l.035-.138 1.711-8.992z"></path></svg></span>
</Wrapper>
          </ul>
      </Navbar>
    </div>
  )
}

export default HomePageMHeader
